<div class="spinner-drop" *ngIf="spinnerService.visibility | async">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div style="position: absolute; bottom: 0; right: 0; z-index: 99999">
  <alert></alert>
</div>
<router-outlet></router-outlet>
